import { getBusiness, getActiveSubscription } from "../services/settings";
import { setBusinessDetails } from "../store/modules/profile";
import { useQueries } from "react-query";
import { useGetProfileDetails } from "./api/queries/useSettings";
import { useDispatch } from "react-redux";
import useGetPermission from "./useGetPermission";
import { useGetDashboardDetails } from "./api/queries/useDashboard";
import { useGetStoreList, useGetTagList } from "./api/queries/useInventory";
import { useEffect } from "react";
import { pathConstants } from "../routes/pathContants";
import { useLocation, useNavigate } from "react-router-dom";

const useRootProperties = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const profileDetails = useGetProfileDetails();
  const hasFetchedProfile = profileDetails?.data ? true : false;
  const { isPermitted: isPermittedToViewDashboard } = useGetPermission({
    permissionChildKey:
      "can_view_payment_dashboard_overview_cash_and_customer_analytics",
    permissionParentKey: "Payments",
  });
  const { isPermitted: isPermittedToViewStore } = useGetPermission({
    permissionChildKey: "can_view_stores",
    permissionParentKey: "Inventory Management",
    showOnLocalSetup: true,
  });
  const { isPermitted: isPermittedToViewTags } = useGetPermission({
    permissionChildKey: "can_view_tags",
    permissionParentKey: "Payments",
  });

  const dashboardDetails = useGetDashboardDetails({
    isEnabled: isPermittedToViewDashboard && hasFetchedProfile,
    queries: "?all_business=true",
    staleTime: Infinity,
    queryName: "getRootDashboardDetails",
  });
  const storeList = useGetStoreList({
    isEnabled: isPermittedToViewStore && hasFetchedProfile,
  });
  const tagDetails = useGetTagList(isPermittedToViewTags && hasFetchedProfile);

  const [activeSubscription, businessDetails] = useQueries([
    {
      queryKey: ["activeSubscription"],
      staleTime: Infinity,
      queryFn: () => getActiveSubscription().then((res) => res?.data?.data),
    },
    {
      queryKey: ["businessDetails"],
      staleTime: Infinity,
      queryFn: () =>
        getBusiness().then((res) => {
          if (res?.data?.data) dispatch(setBusinessDetails(res?.data?.data));
          return res?.data?.data;
        }),
    },
  ]);

  useEffect(() => {
    if (
      !activeSubscription?.data &&
      !activeSubscription?.isLoading &&
      pathname !== pathConstants.SETTINGS_PROFILE &&
      pathname !== pathConstants.SETTINGS_BUSINESS_PROFILE
    )
      navigate(pathConstants.APP_SUBSCRIPTION_PLAN);
  }, [activeSubscription?.isLoading, pathname]);

  return {
    isLoading:
      profileDetails.isLoading ||
      businessDetails.isLoading ||
      activeSubscription?.isLoading ||
      dashboardDetails?.isLoading ||
      storeList?.isLoading ||
      tagDetails?.isLoading,
    activeSubscription: activeSubscription?.data,
  };
};
export default useRootProperties;
